import React from 'react';

const ApplePayIcon: React.FC<React.SVGProps<SVGSVGElement>> = (props) => (
  <svg 
    viewBox="0 0 24 24"
    xmlns="http://www.w3.org/2000/svg"
    className="w-6 h-6"
    {...props}
  >
    <path d="M16.107 13.957c.015-3.48 2.22-5.02 2.42-5.113a.51.51 0 00-.39-.906c-1.253.076-2.93.993-3.87 2.45-1.09-1.57-2.83-2.36-4.38-2.39a.51.51 0 00-.51.488c-.015 3.32 1.95 5.11 3.93 5.11a.51.51 0 00.41-.23c.96-1.46 1.7-3.23 2.92-3.1 1.3.13 1.5 1.51 1.46 2.65zm-3.5-7.462a2.82 2.82 0 01-.98 2.08c-.9.9-2.22.99-3.08.15a2.53 2.53 0 011.02-2.14c.89-.86 2.22-.92 3.04-.09z" fill="#000"></path>
    <path d="M12 0C5.373 0 0 5.373 0 12s5.373 12 12 12 12-5.373 12-12S18.627 0 12 0zm5.35 15.89c-.61.35-1.2.66-1.92.83-.69.17-1.28.27-2.1.27-.85 0-1.5-.15-2.23-.27a5.2 5.2 0 01-1.8-1.02c-.44-.38-.79-.85-1.02-1.4-.24-.55-.38-1.18-.38-1.89 0-1.4.44-2.53 1.34-3.38.9-.85 2.05-1.27 3.44-1.27.63 0 1.3.1 1.96.28.67.19 1.16.48 1.59.83-.16-.25-.24-.53-.24-.84V8.4c0-.62-.2-1.12-.58-1.5-.38-.37-.9-.56-1.54-.56-.63 0-1.16.2-1.59.58-.43.39-.64.88-.64 1.47H7.42c.03-1.12.43-2.06 1.2-2.83a4.53 4.53 0 013.06-1.2c1.07 0 1.98.24 2.7.7.73.47 1.1 1.17 1.1 2.1v4.8c0 .52.07.96.22 1.34a.5.5 0 01-.48.64z" fill="#FFF" fillRule="evenodd"></path>
  </svg>
);

export default ApplePayIcon;